<script setup lang="ts">
import { computed, toRefs } from 'vue';
interface PropsInterface {
  code: string | null;
  classes?: string;
  seeCode?: boolean;
  dividerColor?: string;
  dividerWidth?: string;
  dividerHeight?: string;
}
const props = withDefaults(defineProps<PropsInterface>(), {
  code: '',
  dividerColor: '#d4d9d9',
  dividerWidth: '3px',
  dividerHeight: '16px',
  classes: '',
  seeCode: false,
});

const { code, dividerColor, dividerWidth, dividerHeight } = toRefs(props);

const iconName = computed(() => {
  switch (props.code) {
    case 'SL':
      return 'record_voice_over';
    case 'OT':
      return 'work';
    case 'PT':
      return 'emoji_people';
    case 'SWC':
      return 'handshake';
    case 'PSY':
      return 'psychology';
    case 'BI':
      return 'emoji_objects';
    default:
      return '';
  }
});

const classStyles = computed<string>(() => {
  return `padding-left:3px;  border-left-style: solid; border-left-width: ${dividerWidth.value}; border-left-color: ${dividerColor.value}; height: ${dividerHeight.value}`;
});
</script>

<template>
  <div class="flex align-items-center">
    <span :class="classes" :style="classStyles"></span>
    <Icon :name="iconName" style="color: #7e78d2" />
    <p v-if="seeCode" class="ml-1 text-color-secondary">{{ code }}</p>
  </div>
</template>
